import { Inject, Injectable } from "@angular/core";

import { CommonDialogsService } from "@tylertech/common-dialogs-module";
import { IAggregate, ICardData, ICardAction, ActionType } from "@tylertech/tyler-api-types";

import { IAggregateActionHandler } from "../interfaces";

@Injectable()
export class PopupActionHandler implements IAggregateActionHandler
{
    constructor(
        private readonly $commonDialogsService: CommonDialogsService,
    ) { }

    predicate(_aggregate: IAggregate, _cardData: ICardData, action: ICardAction): boolean
    {
        return action.actionType === ActionType.Popup;
    }

    execute(aggregate: IAggregate, cardData: ICardData, _action: ICardAction): Promise<boolean>
    {
        const label = aggregate.Name;
        const info = this.getField(cardData, "PopupInfo");

        return this.$commonDialogsService.showAlertHtmlMessage(info, label)
            .then(() =>
            {
                return true;
            });
    }

    /**
     * FIXME - This should be in a helper class/service
     * @param cardData
     * @param fieldName
     */
    private getField(cardData: ICardData, fieldName: string): string
    {
        try
        {
            return cardData.DataElements.filter(x => x.Label === fieldName)[0].Value;
        }
        catch (error)
        {
            return null;
        }
    }

    load(_aggregate: IAggregate, _cardData: ICardData, _action: ICardAction): void
    {
        /* NO_OP */
    }
}
